import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  type OnInit,
  ElementRef,
  signal,
  OnDestroy,
  ContentChild,
} from '@angular/core';
import { TemplateMarkerDirective } from '@directives/template-marker.directive';

@Component({
  selector: 'market-intersect-observable',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './intersect-observable.component.html',
  styleUrl: './intersect-observable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntersectObservableComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() minHeight = `100%`;
  @ViewChild('intersect') intersect!: ElementRef<HTMLDivElement>;
  @ContentChild(TemplateMarkerDirective) content!: TemplateMarkerDirective;

  isVisible = signal(false);
  observer: IntersectionObserver | null = null;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible.set(true);
            this.minHeight = 'initial';
            this.observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 } // Adjust the threshold as needed
    );
    this.observer.observe(this.intersect.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
